<script setup>
import {reactive, ref} from 'vue'
import mynav from './components/myNav.vue'
import myfoot from './components/myfoot.vue'

import {useRoute} from "vue-router";
import {onMounted} from "vue";
import {demoInfo} from "@/apis/home";
import {ElMessage} from "element-plus";
const route = useRoute()
const ids = ref(null)
const form = ref(null)
const activeIndex = ref(0)
onMounted(()=>{
  ids.value = route.query.ids
  getInfo()
})
const getInfo = () =>{
  demoInfo({id: ids.value }).then(res=>{
    if(res.code == 200){
      form.value = res.result
    }else{
      ElMessage.error(res.msg);
    }
  })
}

const handleActive = (index) =>{
  activeIndex.value = index
}
const font = reactive({
  color: 'rgba(0, 0, 0, .15)',
})

const typeoption = ref([
  {name:'直链',value:1},
  {name:'百度云',value:2},
  {name:'阿里云',value:3},
])

const getType = (type) =>{
  let str = ''
  typeoption.value.forEach(i=>{
    console.log(type,i.value)
    if(i.value==type){
      str =  i.name
    }
  })
  return str
}
const dialogVisible =ref(false)
const  handleDownload = () =>{
  if(form.value.downloadLinks.length==1 && form.value.downloadLinks[0].url){
    window.open(form.value.downloadLinks[0].url,'_blank')
  }else  if(form.value.downloadLinks.length>1){
    dialogVisible.value = true;
  }else{
    ElMessage.warning('暂无下载地址')
  }
}
const handleClose = () =>{
  dialogVisible.value = false
}
</script>

<template>

  <el-dialog
      v-model="dialogVisible"
      title="下载地址"
      width="500"
      :before-close="handleClose"
  >
    <div class="lists" v-for="i in form.downloadLinks">
      <a :href="i.url">{{getType(i.type)}}</a>
    </div>
  </el-dialog>
<!--  <el-watermark :font="font" content="微信号：x1105064870">-->
    <div>
      <mynav :isShow="false"></mynav>
      <div  v-if="form" class="project-detail-container">
        <!-- 项目头部信息 -->
        <div class="project-header-section">
          <div class="project-basic-info">
            <h1>{{form.title}}</h1>
            <div class="project-tags">
              <span class="language-tag" v-for="(j,indexs) in form.demoTags" >{{j.tagName}}</span>
<!--              <span class="framework-tag">Vue Router</span>-->
<!--              <span class="framework-tag">Vuex</span>-->
            </div>
            <div class="project-stats">
              <span><i class="fas fa-star"></i> 1.2k 星标</span>
              <span><i class="fas fa-code-branch"></i> 234 分支</span>
              <span><i class="fas fa-download"></i> 5.6k 下载</span>
              <span><i class="fas fa-clock"></i> 最近更新：2024-03-15</span>
            </div>
          </div>
          <button class="download-btn large" @click="handleDownload">下载项目</button>
        </div>

        <!-- 项目主要内容 -->
        <div class="project-content">
          <!-- 左侧内容区 -->
          <div class="main-content">
            <!-- 项目预览 -->
            <section class="preview-section">
              <h2>项目预览</h2>
              <div class="preview-container">
                <div class="preview-tabs">
                  <button class="tab-btn " v-if="form.videoUrl" :class="activeIndex==0 ? 'active':''" @click="handleActive(0)">演示视频</button>
                  <button class="tab-btn" v-if="form.contentImage.length" :class="activeIndex==1 ? 'active':''" @click="handleActive(1)">截图展示</button>
                </div>
                <div class="preview-content">
<!--                  <video controls >-->
<!--                    <source src="demo.mp4" type="video/mp4">-->
<!--                    您的浏览器不支持视频播放-->
<!--                  </video>-->
                  <iframe  v-if="activeIndex==0 && form.videoUrl" class="demo-video" :src="'//'+form.videoUrl" scrolling="no" border="0" frameborder="no" framespacing="0" allowfullscreen="true"> </iframe>


                  <div class="screenshot-gallery" v-if="activeIndex==1" >
                    <img  v-for="item in form.contentImage" :src="'/api/public/download?path='+item" alt="项目截图1"/>
                  </div>
                </div>
              </div>
            </section>

            <!-- 项目描述 -->
            <section class="description-section">
              <h2>项目介绍</h2>
              <div class="description-content">
                <p>这是一个基于 Vue.js 的完整电商项目模板，包含以下功能：</p>
                <ul>
                  <li>响应式布局，支持多端适配</li>
                  <li>完整的购物车功能</li>
                  <li>用户认证和授权</li>
                  <li>商品搜索和筛选</li>
                  <li>订单管理系统</li>
                </ul>
                <div class="project-images">
                  <img src="image1.jpg" alt="项目展示图1" class="project-image">
                  <img src="image2.jpg" alt="项目展示图2" class="project-image">
                  <img src="image3.jpg" alt="项目展示图3" class="project-image">
                </div>
              </div>
            </section>

            <!-- 技术栈 -->
            <section class="tech-stack-section">
              <h2>技术栈</h2>
              <div class="tech-stack-grid">
                <div class="tech-item">
                  <img src="vue-logo.png" alt="Vue.js">
                  <span>Vue.js</span>
                </div>
                <div class="tech-item">
                  <img src="vuex-logo.png" alt="Vuex">
                  <span>Vuex</span>
                </div>
                <!-- 更多技术栈项目 -->
              </div>
            </section>
          </div>

          <!-- 右侧信息栏 -->
          <div class="sidebar">
            <div class="author-info">
              <h3>作者信息</h3>
              <div class="author-profile">
                <img src="avatar.jpg" alt="作者头像">
                <div class="author-details">
                  <h4>张三</h4>
                  <p>高级前端工程师</p>
                </div>
              </div>
            </div>

            <div class="project-meta-info">
              <h3>项目信息</h3>
              <ul>
                <li><i class="fas fa-code"></i> 版本：2.0.0</li>
                <li><i class="fas fa-calendar"></i> 发布日期：2024-01-15</li>
                <li><i class="fas fa-file"></i> 文件大小：15.8MB</li>
                <li><i class="fas fa-check-circle"></i> 兼容性：Vue 3.x</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <myfoot></myfoot>

      <div class="banner" v-if="false">
        <div class="contant" v-if="form">
          <iframe  style="width: 1280px;height: 720px;" v-if="form.videoUrl" :src="'//'+form.videoUrl" scrolling="no" border="0" frameborder="no" framespacing="0" allowfullscreen="true"> </iframe>

          <el-carousel v-if="false" indicator-position="outside">
            <el-carousel-item v-for="item in form.contentImage" :key="item">
              <img style="    width: 100%;" :src="'/api/public/download?path='+item" alt="">
            </el-carousel-item>
          </el-carousel>

          <div >
            <h1 style="    color: #03A9F4;">{{form.title}}</h1>
            <div style="display: flex">
              <el-tag style="margin-right: 5px" v-for="(j,indexs) in form.demoTags" :key="indexs" type="primary">{{j.tagName}}</el-tag>
            </div>
            <div>
              <p>{{form.content}}</p>
            </div>
            <div>
              <p>{{form.details}}</p>
            </div>
            <div>
              <h2>下载地址</h2>
              <div>
                <div class="lists" v-for="i in form.downloadLinks">
                  <a :href="i.url">{{getType(i.type)}}</a>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
<!--  </el-watermark>-->

</template>

<style scoped lang="scss">
.lists{
  margin: 4rem 2rem;
}

.lists a{
 text-decoration: none;
  color: #7C4DFF;
  font-size: 16px;
  font-weight: bold;
}
:root {
  --primary-color: #7C4DFF;  /* 更鲜艳的紫色 */
  --secondary-color: #00E5FF; /* 亮青色 */
  --dark-color: #2B2D42;
  --light-color: #F8F9FA;
  --accent-color: #FF4081; /* 粉色强调色 */
  --gradient-start: #7C4DFF;
  --gradient-end: #00E5FF;
  --code-font: 'Fira Code', monospace;
}
.banner{
  width: 1280px;
  height: 100%;
  display: flex;justify-content: center;
  margin: calc(80px + 50px) auto 0;
padding-bottom: 100px;
  font-size: 16px;
}
.contant{

  box-sizing: border-box;
}
.el-carousel__item h3 {
  display: flex;
  color: #475669;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

/* 项目详情页面样式 */
.project-detail-container {
  max-width: 1200px;
  margin: 2rem auto;
  padding: 0 2rem;
  min-height: 80vh;

}

/* 项目头部样式 */
.project-header-section {
  background: white;
  border-radius: 16px;
  padding: 2rem;
  margin-bottom: 2rem;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.project-basic-info h1 {
  font-size: 2.2rem;
  color: var(--dark-color);
  margin-bottom: 1rem;
}

.project-tags {
  display: flex;
  gap: 0.8rem;
  margin-bottom: 1.5rem;
}

.framework-tag {
  background: #e9ecef;
  color: #495057;
  padding: 0.3rem 1rem;
  border-radius: 20px;
  font-size: 0.85rem;
}

.project-stats {
  display: flex;
  gap: 1.5rem;
  color: #666;
}

.project-stats span {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.download-btn.large {
  padding: 1rem 3rem;
  font-size: 1.1rem;
}

/* 主要内容区布局 */
.project-content {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 2rem;
}

/* 预览部分样式 */
.preview-section {
  background: white;
  border-radius: 16px;
  padding: 2rem;
  margin-bottom: 2rem;
}

.preview-tabs {
  display: flex;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.tab-btn {
  padding: 0.8rem 1.5rem;
  border: none;
  background: #f8f9fa;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.tab-btn.active {
  background: #7C4DFF;
  color: white;
}

.preview-content {
  border-radius: 12px;
  overflow: hidden;
}

.demo-video {
  width: 100%;
  height: 336px;
  border-radius: 12px;
}

.screenshot-gallery {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
}

.screenshot-gallery img {
  width: 100%;
  border-radius: 8px;
  transition: transform 0.3s ease;
}

.screenshot-gallery img:hover {
  transform: scale(1.05);
}

/* 描述部分样式 */
.description-section {
  background: white;
  border-radius: 16px;
  padding: 2rem;
  margin-bottom: 2rem;
}

.description-content ul {
  margin-top: 1rem;
  padding-left: 1.5rem;
}

.description-content li {
  margin-bottom: 0.5rem;
  color: #495057;
}

/* 技术栈样式 */
.tech-stack-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  gap: 1.5rem;
  margin-top: 1.5rem;
}

.tech-item {
  text-align: center;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 12px;
  transition: transform 0.3s ease;
}

.tech-item:hover {
  transform: translateY(-5px);
}

.tech-item img {
  width: 48px;
  height: 48px;
  margin-bottom: 0.5rem;
}

/* 侧边栏样式 */
.sidebar > div {
  background: white;
  border-radius: 16px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
}

.author-profile {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-top: 1rem;
}

.author-profile img {
  width: 60px;
  height: 60px;
  border-radius: 50%;
}

.project-meta-info ul {
  list-style: none;
  margin-top: 1rem;
}

.project-meta-info li {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  margin-bottom: 0.8rem;
  color: #495057;
}

/* 响应式设计 */
@media (max-width: 968px) {
  .project-content {
    grid-template-columns: 1fr;
  }

  .project-header-section {
    flex-direction: column;
    gap: 1.5rem;
  }

  .download-btn.large {
    width: 100%;
  }

  .project-stats {
    flex-wrap: wrap;
    gap: 1rem;
  }
}

@media (max-width: 576px) {
  .project-detail-container {
    padding: 0 1rem;
  }

  .project-basic-info h1 {
    font-size: 1.8rem;
  }

  .project-tags {
    flex-wrap: wrap;
  }
}

.download-btn {
  background: linear-gradient(135deg,  #7C4DFF, #00E5FF);
  color: white;
  padding: 0.8rem 2rem;
  border-radius: 25px;
  font-weight: 600;
  font-size: 0.9rem;
  letter-spacing: 0.5px;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;
  margin-top: 1rem;
  width: 300px;
}

.download-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(124, 77, 255, 0.3);
}

</style>
